import Swiper from "swiper";
import { Navigation, Pagination, EffectFade } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/effect-fade";

// Testimonials Slider
const testimonialsSwipers = document.querySelectorAll(".testimonials-swiper");
testimonialsSwipers.forEach((swiperEl) => {
  new Swiper(swiperEl, {
    modules: [Navigation, Pagination, EffectFade],
    effect: "fade",
    fadeEffect: {
      crossFade: true,
    },
    loop: true,
    slidesPerView: 1,
    speed: 800,
    navigation: {
      nextEl: swiperEl.parentNode.querySelector(
        ".swiper-navigation-arrows-next",
      ),
      prevEl: swiperEl.parentNode.querySelector(
        ".swiper-navigation-arrows-prev",
      ),
    },
    pagination: {
      el: swiperEl.parentNode.querySelector(".swiper-pagination"),
      clickable: true,
    },
  });
});

// Card Slider
const cardSwipers = document.querySelectorAll(".card-swiper");
cardSwipers.forEach((swiperEl) => {
  const cardCount = parseInt(swiperEl.dataset.cardCount, 10) || 0;

  var cardInnerParent = swiperEl.closest(".card-slider-inner");
  var cardSliderContainer = swiperEl.closest(".card-slider-container");

  // Only initialize swiper if there's more than one card
  if (cardCount > 1) {
    const nextArrow = cardInnerParent.querySelector(
      ".swiper-navigation-arrows-next",
    );
    const prevArrow = cardInnerParent.querySelector(
      ".swiper-navigation-arrows-prev",
    );

    // Function to center arrows vertically on container for large screens
    const centerArrowsOnContainer = () => {
      if (window.innerWidth > 992 && cardSliderContainer) {
        const containerRect = cardSliderContainer.getBoundingClientRect();
        const containerTop = cardSliderContainer.offsetTop;
        const containerHeight = containerRect.height;
        const arrowHeight = nextArrow ? nextArrow.offsetHeight : 0;
        const topPosition =
          containerTop + containerHeight / 2 - arrowHeight / 2;

        if (nextArrow) {
          nextArrow.style.top = `${topPosition}px`;
        }
        if (prevArrow) {
          prevArrow.style.top = `${topPosition}px`;
        }
      } else {
        // Reset styles for smaller screens
        if (nextArrow) nextArrow.style.top = "";
        if (prevArrow) prevArrow.style.top = "";
      }
    };

    var cardSwiper = new Swiper(swiperEl, {
      modules: [Navigation, Pagination, EffectFade],
      effect: "fade",
      fadeEffect: {
        crossFade: true,
      },
      loop: false,
      slidesPerView: 1,
      speed: 800,
      navigation: {
        nextEl: nextArrow,
        prevEl: prevArrow,
      },
      pagination: {
        el: cardInnerParent.querySelector(".swiper-pagination"),
        clickable: true,
      },
      on: {
        init: function () {
          centerArrowsOnContainer();
        },
      },
    });

    // Recalculate on window resize
    window.addEventListener("resize", centerArrowsOnContainer);
  }
});

// Gallery Slider (in modals)
const gallerySwipers = document.querySelectorAll(".gallery-swiper");
gallerySwipers.forEach((swiperEl) => {
  const galleryCount = parseInt(swiperEl.dataset.galleryCount, 10) || 0;
  const container = swiperEl.closest(".modal-content");

  if (galleryCount > 1 && container) {
    new Swiper(swiperEl, {
      modules: [Navigation, Pagination],
      loop: true,
      slidesPerView: 1,
      speed: 500,
      navigation: {
        nextEl: container.querySelector(".gallery-next"),
        prevEl: container.querySelector(".gallery-prev"),
      },
      pagination: {
        el: container.querySelector(".gallery-pagination"),
        clickable: true,
        type: "fraction",
      },
    });
  }
});
